import { render, staticRenderFns } from "./QueryPolicyRiskTrailer.vue?vue&type=template&id=7c403319&"
import script from "./QueryPolicyRiskTrailer.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyRiskTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports